import React from "react";

const RecipeCard = React.memo(({ 
  recipe, 
  onView, 
  onEdit, 
  onDelete, 
  animationClass = ''
}) => {
  const formatServings = (servings) => {
    const parsedServings = parseFloat(servings);
    if (Number.isInteger(parsedServings)) {
      return parsedServings.toFixed(0);
    } else {
      return parsedServings.toFixed(1);
    }
  };

  return (
    <div className={`recipe-card-item recipe-card ${animationClass}`}>
      <div className="recipe-info">
        <div className="recipe-details">
          <div className="recipe-name">{recipe.name}</div>
          <div className="recipe-meta">
            {recipe.meal_qty > 1 && <span className="multiplier">{recipe.meal_qty}x</span>}
            <span className="servings">({formatServings(recipe.updated_servings)} servings)</span>
          </div>
        </div>
        <div className="recipe-actions">
          <button 
            className="action-btn view-btn" 
            onClick={() => onView(recipe.recipe_id)}
            title="View Recipe"
          >
            <i className="fas fa-eye"></i>
          </button>
          <button 
            className="action-btn edit-btn" 
            onClick={() => onEdit(recipe)}
            title="Edit"
          >
            <i className="fas fa-pencil-alt"></i>
          </button>
          <button 
            className="action-btn delete-btn" 
            onClick={() => onDelete(recipe)}
            title="Delete"
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  );
});

export default RecipeCard;